module.exports = __webpack_public_path__ + "img/spider_egg_hatchery_small.70a712f1.png";